export default __webpack_public_path__ + "static/media/successfull.637751aa.png";